module.exports = __webpack_public_path__ + "img/approved.f9b9fbc6.svg";